module.exports = __webpack_public_path__ + "static/irene_1-bf7e242c755a70b3808f66998e088ebf.png";